import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Languages, Pause, Play, RefreshCw } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Progress } from "../components/ui/progress";

export function TranslatePanel() {
  const [s, setS] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/translate-status").then((r) => setS(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  const act = async (action) => {
    try {
      await api.post("/admin/translate", { action });
      toast.success(action === "run" ? "Traduzione avviata" : action === "pause" ? "Traduzione in pausa" : "Traduzione riattivata");
      setTimeout(load, 800);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!s) return null;
  const pct = s.total ? Math.round((s.translated / s.total) * 1000) / 10 : 0;
  return (
    <div className="rounded-xl border border-white/10 bg-[#0d2233] p-5 space-y-4" data-testid="translate-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-bold text-white flex items-center gap-2"><Languages size={18} /> Descrizioni in italiano</h2>
          <p className="text-sm text-slate-300">Traduzione automatica con Gemini Flash: i giochi nuovi del feed subito, gli altri a blocchi ogni 15 minuti.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="icon" onClick={load} className="text-slate-200 hover:bg-white/10 hover:text-white" data-testid="translate-refresh-btn"><RefreshCw size={16} /></Button>
          {s.enabled ? (
            <>
              <Button disabled={s.running} onClick={() => act("run")} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="translate-run-btn"><Play size={16} /> {s.running ? "In corso..." : "Traduci ora"}</Button>
              <Button variant="outline" onClick={() => act("pause")} className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:text-white" data-testid="translate-pause-btn"><Pause size={16} /> Pausa</Button>
            </>
          ) : (
            <Button onClick={() => act("resume")} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="translate-resume-btn"><Play size={16} /> Riattiva</Button>
          )}
        </div>
      </div>
      <Progress value={pct} className="h-3 bg-white/10 [&>div]:bg-[#fc0]" data-testid="translate-progress" />
      <div className="flex flex-wrap justify-between gap-2 text-sm text-slate-200">
        <span data-testid="translate-count">{s.translated.toLocaleString("it-IT")} di {s.total.toLocaleString("it-IT")} tradotti ({pct}%)</span>
        <span className={s.enabled ? "text-emerald-300" : "text-yellow-200"}>{s.enabled ? (s.running ? "Traduzione in corso" : "Attiva") : "In pausa"}</span>
      </div>
      {s.failed > 0 && <p className="text-xs text-slate-300">{s.failed} giochi non tradotti dopo 3 tentativi (restano in inglese).</p>}
      {s.error && <p className="text-xs text-red-300" data-testid="translate-error">Ultimo errore: {s.error}</p>}
    </div>
  );
}
